module.exports = __webpack_public_path__ + "static/media/alis14.9d1aa862.jpg";